import { Component, inject, input } from '@angular/core';
import { StoryblokDirective } from '../../../directives/storyblok.directive';
import { 
  RdsButtonModule,
  RdsIconsModule,
  RdsLinkModule,
} from '@rds/angular-components';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';
import { Components } from '../../../components';
import { DynamicModule } from 'ng-dynamic-component';
import { ImageComponent } from "../../shared/image/image.component";

@Component({
  selector: 'inexp-promo',
  imports: [
    StoryblokDirective,
    RdsButtonModule,
    RdsIconsModule,
    RdsLinkModule,
    NgClass,
    DynamicModule,
    ImageComponent
],
  templateUrl: './promo.component.html',
  styleUrl: './promo.component.scss'
})
export class PromoComponent {
  router = inject(Router);
  _editable = input<string>();
  _uid = input<string>();
  component = input<string>();

  title = input<string>();
  subtitle = input<string>();
  image = input<any>();
  buttons = input<any[]>();
  background = input<string>();
  rtl = input<boolean>(false);
  imageWidthPercentage = input<number>();
  description = input<any[]>();
  links = input<any[]>();

  components = Components;

}
